import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  text: {
    padding: '5px 10px',
    borderRadius: 20,
    color: `${theme.palette.error.contrastText} !important`,
    width: 'fit-content',
    display: 'flex',
    '& svg': {
      fontSize: 22,
      verticalAlign: 'text-top',
      marginLeft: 5,
      color: `${theme.palette.error.contrastText} !important`,
      '&:hover': { color: theme.palette.error.contrastText }
    }
  },
  red: {
    backgroundColor: theme.palette.error.main
  },

  green: {
    backgroundColor: theme.palette.success.main
  },

  blue: {
    backgroundColor: theme.palette.info.main
  },

  grey: {
    backgroundColor: theme.palette.grey[500]
  }
}))

export default useStyles
